module.exports = __webpack_public_path__ + "static/img/cpzx_nav_7@2x.22a51cd1.png";